<template>
    <div
        :data-component-name="$options.name"
    >

        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            clearable
            :dense="dense"
            :filled="filled"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            use-input
            option-value="id"
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:option="scope">
              <q-item
                v-bind="scope.itemProps"
                v-on="scope.itemEvents"
              >
                <q-item-section side class="q-mr-none" dense>
                    <q-icon name="bookmark"
                        size="16px"
                        :style="'color: ' + scope.opt.color"
                    />
                </q-item-section>
                <q-item-section dense>
                  <q-item-label v-html="scope.opt.label" />
                </q-item-section>
              </q-item>
            </template>

            <template v-slot:selected-item="scope">
                <span v-if="scope.index > 0" class="q-mr-xs">, </span>
                <span
                >
                    <q-icon name="bookmark"
                        size="14px"
                        :style="'color: ' + scope.opt.color"
                    />
                    {{ scope.opt.label }}
                    <!-- <q-icon name="cancel"
                        class="cursor-pointer"
                        color="grey"
                        size="12px"
                        @click="scope.removeAtIndex(scope.index)"
                        :tabindex="scope.tabindex"
                    /> -->

                </span>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { /*COMPANIES/*, COMPANIESSEARCH/*, CONTACTS, LOCATIONS*/ } from '@/graphql/company/queries'
    import { COMPANYCATEGORIES, COMPANYCATEGORIESSEARCH } from '@/graphql/category/queries'
    import QSelect from 'quasar'

    export default {
        name: 'CompaniesInput',
        extends: QSelect,
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        data(){
            return {
                searchTO: {}
            }
        },
        computed: {
            menuItems() {
                if (this.$apollo.queries.companyCategories && !this.$apollo.queries.companyCategories.loading) {
                    this.companyCategories.forEach(item => {
                        item.label = item.name
                        delete(item.__typename)
                    })
                    return this.companyCategories
                }
                return [];
            }
        },
        methods: {
            search(searchText, updatefn){
                clearTimeout(this.searchTO);
                if(searchText && searchText!=""){
                    this.searchTO=setTimeout(function(){
                        if(this.$apollo.queries.companyCategoriesSearch){
                            delete this.$apollo.queries.companyCategoriesSearch
                        }
                        this.$apollo.addSmartQuery('companyCategoriesSearch', {
                            query: COMPANYCATEGORIESSEARCH,
                            fetchPolicy: 'cache-first',
                            error(error) {
                                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                            },
                            variables: {
                                searchText: searchText.trim().split(" ").join("* ")+"*",
                            },
                            manual: true,
                            result ({ data }) {
                                this.companyCategories = Object.assign([], data.companyCategoriesSearch);
                                updatefn();
                            },
                        })
                    }.bind(this), 200)
                }else{
                    this.$apollo.queries.companyCategories.refresh()
                    updatefn();
                }
            }
        },
        apollo: {
            companyCategories: {
                query: COMPANYCATEGORIES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(companyCategories) {
                    companyCategories=companyCategories.companyCategories;


                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)
                    
                    return companyCategories;
                },
                variables() {
                    if(this.variables) return {...this.variables}
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .companyCategories {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>